import React from "react";

export default function MapPin({ size = 44 }) {
  return (
    <svg
      width={size}
      version="1.1"
      viewBox="0 0 40 44"
      style={{
        height: "auto",
        cursor: "pointer",
        transform: `translate(${-size / 2}px,${-size}px)`
      }}
    >
      <circle className="pulse" fill="white" cx="20" cy="20" r="20" />
      <circle className="pulse-mask" fill="white" cx="20" cy="20" r="10" />
      <path
        className="pin"
        fill="#E8004D"
        d="M20.0000306,44 C19.7350299,44 19.5199462,43.7868637 19.5199462,43.5237206 C19.5199462,36.2598525 16.6237794,33.3885819 11.8256268,28.6304 L11.5146241,28.3228332 C6.8282955,23.6734042 6.82854019,16.1357119 11.5148688,11.4867683 C16.2011975,6.83758206 23.7993531,6.83782481 28.485437,11.4870111 C33.171521,16.1361974 33.171521,23.6736469 28.485437,28.3228332 L28.1744343,28.6304 C23.3743242,33.3922232 20.480115,36.2598525 20.480115,43.5237206 C20.480115,43.7868637 20.2650313,44 20.0000306,44 Z M20.0000306,14.1902002 C16.8187984,14.1902002 14.2399963,16.7485636 14.2399963,19.9045823 C14.2399963,23.060601 16.8187984,25.6189643 20.0000306,25.6189643 C23.1812628,25.6189643 25.7600648,23.060601 25.7600648,19.9045823 C25.7600648,16.7485636 23.1812628,14.1902002 20.0000306,14.1902002 Z"
      />
    </svg>
  );
}
